<template>
  <div class="search">
    <div class="cu-bar bg-red search-box flex align-center">
      <div class="search-form radius flex align-center justify-between">
        <input :focus="true" @blur="InputBlur" @confirm="inputConfirm" :adjust-position="false" type="text"
          placeholder-class="search-pla" placeholder="请输入换电站名称、地址" confirm-type="search" v-model="searchValue"></input>
        <img @click="search"
          src="https://sass.gclme.com/api/file/Image/annex/20220105_09247b22879142e98d3ff8e32cf67029.png" mode="" />
      </div>
    </div>
    <div class="history">
      <div v-show="isGetList">
        <div class="flex justify-between align-center text-lg text-black margin-bottom-xl">
          “{{searchValue}}”的搜索结果
        </div>
        <div class="history-list" v-for="(item,index) in searchList" :key="index" data-id="item.stationName"
          @click="chooseMap()">
          <div class="detail-type">
            <span>{{item.stationName}}</span>
            <span>{{item.detailedAddress}}</span>
          </div>
          <van-icon name="guide-o" class="text-icon" />
        </div>
      </div>
    </div>
    <van-action-sheet
      v-model="sheetShow"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelect"
    />
  </div>
</template>
<script type="text/javascript">
  import AMapLoader from '@amap/amap-jsapi-loader';
  import {
    Toast
  } from 'vant';
  export default {
    name: 'searchMap',
    data() {
      return {
        searchValue: '',
        searchList: [], // 搜索结果页
        isGetList: false,
        longitude: null, //经度
        latitude: null, //纬度
        sheetShow: false,
        actions : [
          { id:1, name: '高德地图' },
          { id:2, name: '百度地图' },
          { id:3, name: '腾讯地图' },
        ],
      }
    },
    watch: {
      searchValue: {
        immediate: true,
        handler() {
          this.isGetList = false
        }
      },
    },
    created() {
      document.title = "地图站点搜索"
      this.location = this.$route.query.location ? this.$route.query.location.split(",") : [116.379028, 39.865042];
    },
    methods: {
      chooseMap(){
        this.sheetShow = true;
      },
      onSelect(item){
        this.guide(item.id, item)
      },
      guide(signMap, item) {
        uni.showLoading({
          title: '跳转中'
        });
        if (item.stationName && item.stationName != '') {
          //景点位置position.name 景点经纬度lng lat
          var lng = item.longitude;
          var lat = item.latitude;
          if (signMap == 1) {
            // 高德地图
            uni.getSystemInfo({
              success: (res) => {
                if (res.platform === "android") {
                  window.location.href =
                    "androidamap://viewMap?sourceApplication=appname&poiname=" + item
                    .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
                  //判断是否跳转
                  setTimeout(function() {
                    let hidden = window.document.hidden || window.document
                      .mozHidden || window.document.msHidden || window.document
                      .webkitHidden
                    if (typeof hidden == "undefined" || hidden == false) {
                      //调用高德地图
                      window.location.href =
                        "https://uri.amap.com/marker?position=" + lng + "," +
                        lat + "&name=" + item.stationName;
                    }
                  }, 2000);
                } else {
                  window.location.href =
                    "iosamap://viewMap?sourceApplication=appname&poiname=" + item
                    .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
                  //判断是否跳转
                  setTimeout(function() {
                    let hidden = window.document.hidden || window.document
                      .mozHidden || window.document.msHidden || window.document
                      .webkitHidden
                    if (typeof hidden == "undefined" || hidden == false) {
                      //调用高德地图
                      window.location.href =
                        "https://uri.amap.com/marker?position=" + lng + "," +
                        lat + "&name=" + item.stationName;
                    }
                  }, 2000);
                }
              }
            })
          } else if (signMap == 2) {
            // 百度地图
            uni.getSystemInfo({
              success: (res) => {
                if (res.platform === "android") {
                  let d = new Date();
                  let t0 = d.getTime();
                  window.location.href =
                    "androidamap://viewMap?sourceApplication=appname&poiname=" + item
                    .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
                  //由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
                  var delay = setInterval(function() {
                    var d = new Date();
                    var t1 = d.getTime();
                    if (t1 - t0 < 3000 && t1 - t0 > 2000) {
                      window.location.href =
                        "http://api.map.baidu.com/marker?location=" + lat +
                        "," + lng + "&title=" + item.stationName +
                        "&content=站点&output=html&src=webapp.baidu.openAPIdemo";
                    }
                    if (t1 - t0 >= 3000) {
                      clearInterval(delay);
                    }
                  }, 1000);
                } else {
                  let d = new Date();
                  let t0 = d.getTime();
                  window.location.href =
                    "iosamap://viewMap?sourceApplication=appname&poiname=" + item
                    .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
                  //由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
                  let delay = setInterval(function() {
                    var d = new Date();
                    var t1 = d.getTime();
                    if (t1 - t0 < 3000 && t1 - t0 > 2000) {
                      window.location.href =
                        "http://api.map.baidu.com/marker?location=" + lat +
                        "," + lng + "&title=" + item.stationName +
                        "&content=站点&output=html&src=webapp.baidu.openAPIdemo";
                    }
                    if (t1 - t0 >= 3000) {
                      clearInterval(delay);
                    }
                  }, 1000);
                }
              }
            })
          } else {
            // 腾讯地图
            uni.getSystemInfo({
              success: (res) => {
                if (res.platform === "android") {
                  window.location.href =
                    "androidamap://viewMap?sourceApplication=appname&poiname=" + item
                    .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
                  //判断是否跳转
                  setTimeout(function() {
                    let hidden = window.document.hidden || window.document
                      .mozHidden || window.document.msHidden || window.document
                      .webkitHidden
                    if (typeof hidden == "undefined" || hidden == false) {
                      //调用腾讯地图
                      window.location.href =
                        `https://apis.map.qq.com/uri/v1/marker?marker=coord:(${lat},${lng})&addr:${item.stationName}`
                    }
                  }, 2000);
                } else {
                  window.location.href =
                    "iosamap://viewMap?sourceApplication=appname&poiname=" + item
                    .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
                  //判断是否跳转
                  setTimeout(function() {
                    let hidden = window.document.hidden || window.document
                      .mozHidden || window.document.msHidden || window.document
                      .webkitHidden
                    if (typeof hidden == "undefined" || hidden == false) {
                      //调用高德地图
                      window.location.href =
                        `https://apis.map.qq.com/uri/v1/marker?marker=coord:(${lat},${lng})&addr:${item.stationName}`
                    }
                  }, 2000);
                }
              }
            })
          }
        } else {
          Toast.loading({
            message: '未获取到该站点位置...',
            forbidClick: true
          });
        }
      },
      InputBlur(e) {
        this.searchValue = e && e.currentTarget && e.currentTarget.value
        if (this.searchValue != '') {
          this.getList();
        }
      },
      inputConfirm(e) {
        this.searchValue = e && e.detail && e.detail.value
        if (!this.searchValue) {
          Toast.loading({
            message: '请输入搜索内容...',
            forbidClick: true
          });
        } else {
          this.getList();
        }
      },
      search(item) {
        if (!this.searchValue) {
          Toast.loading({
            message: '请输入搜索内容...',
            forbidClick: true
          });
        } else {
          this.getList();
        }
      },
      getList() {
        let _this = this;
        this.$http({
            method: 'get',
            url: `${this.define}/api/changepower/changePowerList/gcl`,
            params: {
              'stationName': this.searchValue,
              'onlyShowOpeningStation' : 1
            }
          }).then(({
            data
          }) => {
            if (data.data.list.length > 0) {
              this.isGetList = true
              _this.announcement2 = data.data.list
              _this.searchList = [];
              _this.searchList = _this.searchList.concat(_this.announcement2); //追加新数据
            } else {
              this.isGetList = false
              Toast.loading({
                message: '没有找到店铺哦...',
                forbidClick: true
              });
            }
          })
          .catch(err => {
            this.isGetList = false
          });
      }
    }
  }
</script>
<style lang="stylus" scoped>
  
</style>



// WEBPACK FOOTER //
// searchMap.vue?5ee2b8d5